// extracted by mini-css-extract-plugin
module.exports = {"Root":"DraggableIntervals_Root__18R8L","Editor":"DraggableIntervals_Editor__3EZlh","CanvasHolder":"DraggableIntervals_CanvasHolder__1PCet"};